import {
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
} from '@mui/material';
import React from 'react';

const ExternalQuotaAccordian = (props) => {
  const { data, quotaKey = 'externalHoursQuota' } = props;

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const years = [
    { prevYear: new Date().getFullYear() - 1 },
    { thisYear: new Date().getFullYear() },
    { nextYear: new Date().getFullYear() + 1 },
  ];

  return (
    <>
      <AccordionDetails>
        {
          <Grid item xs={12}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  {months.map((val, index) => {
                    return (
                      <TableCell key={index} align="center">
                        {val}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {years.map((year, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell>{year[Object.keys(year)[0]]}</TableCell>
          {data[quotaKey]?.[Object.keys(year)[0]]?.map(
                        (val, id) => {
                          return (
                            <TableCell
                              key={id}
                              align="center"
                              style={{
                                backgroundColor: val > 18 ? 'yellowgreen' : '',
                              }}
                            >
                              {val}
                            </TableCell>
                          );
                        },
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        }
      </AccordionDetails>
    </>
  );
};

export default ExternalQuotaAccordian;
